export const alertsSelector = (state) => {
  return state.getIn(["alertsv2", "alerts"]);
};
